import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog__header flex flex-column" }
const _hoisted_2 = {
  key: 1,
  class: "py-3"
}
const _hoisted_3 = { key: 2 }

import { ref, toRefs, onMounted } from 'vue';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import { EMIT, PERMISSIONS } from '@/enum';
import { useOverageStore } from '@/store';
import { can } from '@/composables';

import SeatsPerDiscipline from './SeatsPerDiscipline.vue';
interface Props {
  organizationId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SeatsInUseModal',
  props: {
    organizationId: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { organizationId } = toRefs(props);

const emit = __emit;

const overageStore = useOverageStore();

const modalVisible = ref<boolean>(true);
const month = ref<Date>(new Date());

const cancel = (): void => {
  emit(EMIT.CANCEL);
  modalVisible.value = false;
};

const getOverages = async () => {
  if (can([PERMISSIONS.OVERAGES_LIST])) {
    overageStore.loading.modal = true;
    await overageStore.getOrganizationOverages(organizationId.value, month.value, false);
    overageStore.loading.modal = false;
  }
};

onMounted(async () => {
  await getOverages();
});

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    draggable: false,
    modal: true,
    class: "dialog__container",
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "mb-3" }, "Seats in Use", -1)),
        _createElementVNode("div", null, [
          _createVNode(_unref(Calendar), {
            modelValue: month.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
            view: "month",
            "date-format": "MM",
            "show-icon": true,
            "manual-input": false,
            "icon-display": "input",
            onDateSelect: getOverages
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(overageStore).loading.modal)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            class: "flex justify-content-center align-items-center h-full loader"
          }))
        : _createCommentVNode("", true),
      (_unref(overageStore).overage_list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(overageStore).overage_list, (overage, index) => {
              return (_openBlock(), _createBlock(SeatsPerDiscipline, {
                key: index,
                overage: overage
              }, null, 8, ["overage"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "no-services alert-red font-semibold bg-white align-content-center text-center" }, " No applicable services for this month ", -1)
          ]))]))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})